export default __webpack_public_path__ + "static/15-94d094a55139f6e5eaa2a79f75032c54.webp";